import React from "react";
import './cellFontSize.scss';

// A functional component to render the box
const ValueBox = ({ value }) => {
  // Function to determine the background color based on the value
  const getColor = (value) => {
    if (value >= 0 && value <= 30) {
      return "#FFF7E6"; // Amber
    } else if (value < 0) {
      return "#FFE6E6"; // Light red
    }
    return "#E6F7F0"; // Light green

  };

  // Function to determine the text color
  const getTextColor = (value) => {
    if (value >= 0 && value <= 30) {
      return "#FF0000"; // Green for positive values
    } else if (value < 0) {
      return "#FF0000"; // Red for negative values
    }
    return "#008000";; // Default text color
  };

  return (
    <div
      className="value-box"
      style={{
        backgroundColor: getColor(value),
      }}
    >
      <span
        className="text-content"
        style={{
          color: getTextColor(value),
        }}
      >
        {Math.abs(value)}
      </span>
    </div>
  );
};


export default ValueBox;
